class UnsupportedTriggers {
    static readonly unsupportedTriggers = ["HttpTrigger", "HttpApiTrigger"];
    static readonly unsupportedTriggersMessage = `This Template can not be used because it contains some of the following Triggers: ${this.unsupportedTriggers.join(", ")}`;
}

export default UnsupportedTriggers;
